import React,{Component} from 'react';
class Story extends Component {
  constructor(props) {
    super(props);
    this.state = {
      story: ""
    };
  }


  componentWillMount() {
    var thisState = this;
    fetch('/serverapi/getuserstory', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ok : ""})
      }).then((resp) => resp.json())
        .then(function(data) {
          thisState.setState({ story: data.story[0].story_content})
        })
  }
  render () {
    return(
      <div className="main" style={{ overflow: "scroll"}}>
        <div className="outer">
            <div className="middle">
                <div className="inner">
            <div className="story row">
              <div className="col-md-2" />
              <div className="col-md-8">
                <h2 className="text-sm-center">Story</h2><br/>
                <p className="text-md-left" dangerouslySetInnerHTML={{__html:this.state.story}} />
              </div>
              <div className="col-md-2" />
            </div>
          </div>
      </div>
    </div>
  </div>

    )
  }
}

export default Story;



// WEBPACK FOOTER //
// ./src/pages/Story.js